export default __webpack_public_path__ + "static/media/6.41eae060.jpg";